import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Company } from '../../../dto/company';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Country } from '../../../dto/country';
import { ActivatedRoute } from '@angular/router';
import { CountryService } from '../../../services';
import { Location } from '@angular/common';
import { PHONE_MASK, IBAN_PATTERN } from '../../../helpers/format-helpers';
import { environment } from '../../../../environments/environment';
import { CompanyService } from '../../services/company.service';

@Component({
  selector: 'app-company-edit',
  templateUrl: './company-edit.component.html',
  styleUrls: ['./company-edit.component.css']
})
export class CompanyEditComponent implements OnInit {
  company: Company;
  countries: Country[];
  companyForm: FormGroup;
  phoneMask = PHONE_MASK;
  orderURLHintText: string;
  brandReferralURLHintText: string;
  orderUrlLink: string;
  brandReferralUrlLink: string;

  @ViewChild('fileInput', { static: false }) logoInput: ElementRef;
  @ViewChild('fileInputCardsImage', { static: false }) cardsImageInput: ElementRef;

  constructor(private route: ActivatedRoute,
    private companiesService: CompanyService,
    private formBuilder: FormBuilder,
    private countryService: CountryService,
    private location: Location
  ) { }
  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id == null) {
      this.initForm({} as Company);
    } else {
      this.companiesService.get(parseInt(id)).subscribe(result => {
        this.initForm(result);
      });
    }
    this.countryService.getMany().subscribe(x => {
      this.countries = x.data;
    });
  }

  initForm(company: Company) {
    this.orderURLHintText = '( ' + location.origin + '/order/' + company.orderUrl + ' )';
    this.brandReferralURLHintText = '( ' + location.origin + '/brand/' + company.brandReferralCode + ' )';
    this.orderUrlLink = `/order/${company.orderUrl}`;
    this.brandReferralUrlLink = `/brand/${company.brandReferralCode}`;
    this.companyForm = this.formBuilder.group({
      id: company.id,
      logoId: company.logoId,
      logoUrl: company.logoFileName ? environment.apiUrl + company.logoFileName : null,
      name: company.name,
      brandName: company.brandName,
      directorName: company.directorName,
      directorFirstName: company.directorFirstName,
      directorJobTitle: company.directorJobTitle,
      directorJobTitleEn: company.directorJobTitleEn,
      email: company.email,
      phone: company.phone,
      websiteUrl: company.websiteUrl,
      countryIsoCode: company.countryIsoCode,
      countryName: company.countryName,
      city: company.city,
      address: company.address,
      postcode: company.postcode,
      vatRegNr: company.vatRegNr,
      vatRate: company.vatRate,
      orderUrl: company.orderUrl,
      orderMethod: company.orderMethod,
      active: company.active,
      bankName: company.bankName,
      bankSortCode: company.bankSortCode,
      bankBranchNo: company.bankBranchNo,
      accountNo: company.accountNo,
      iban: [company.iban, [Validators.pattern(IBAN_PATTERN)]],
      bic: company.bic,
      swift: company.swift,
      sofortPaymentEnabled: company.sofortPaymentEnabled,
      cashOnDeliveryPaymentEnabled: company.cashOnDeliveryPaymentEnabled,
      invoicePaymentEnabled: company.invoicePaymentEnabled,
      voucherPaymentEnabled: company.voucherPaymentEnabled,
      creditCardPaymentEnabled: company.creditCardPaymentEnabled,
      webIdForBulkOrdersEnabled: company.webIdForBulkOrdersEnabled,
      orderLanguage: company.orderLanguage,

      directInvoicingEnabled: company.directInvoicingEnabled,
      supportPhone: company.supportPhone,
      supportEmail: company.supportEmail,
      googleAnalyticsCode: company.googleAnalyticsCode,
      facebookPixelId: company.facebookPixelId,
      cardProcessorEnquiryEnabled: company.cardProcessorEnquiryEnabled,
      partnerWalletEnabled: company.partnerWalletEnabled,
      canCreateWallets: company.canCreateWallets,

      facebookUrl: company.facebookUrl,
      instagramUrl: company.instagramUrl,
      tikTokUrl: company.tikTokUrl,
      youTubeUrl: company.youTubeUrl,


      cardsImageId: company.cardsImageId,
      cardsImageUrl: company.cardsImageFileName ? environment.apiUrl + company.cardsImageFileName : null,

      customerNumber: company.customerNumber,
      fxRateMargin: company.fxRateMargin,
      partnerWalletDefaultLoadFee: company.partnerWalletDefaultLoadFee,
      brandReferralCode: company.brandReferralCode,

    });
  }

  returnBack() {
    this.location.back();
  }

  onSubmit(form: FormGroup) {
    if ((form.value.voucherPaymentEnabled || form.value.invoicePaymentEnabled || form.value.sofortPaymentEnabled || form.value.cashOnDeliveryPaymentEnabled)) {
      if (form.value.id) {
        this.companiesService.update(form.value.id, form.value)
          .subscribe(() => this.returnBack());
      } else {
        this.companiesService.add(form.value)
          .subscribe(() => this.returnBack());
      }
    }
  }


  uploadImage(event) {
    const file = event.target.files[0];

    this.companiesService.addImage(file).subscribe(result => {
      this.companyForm.patchValue({ logoId: result.id, logoUrl: result.fileUrl });
    });
  }

  uploadCardsImage(event) {
    const file = event.target.files[0];

    this.companiesService.addImage(file).subscribe(result => {
      this.companyForm.patchValue({ cardsImageId: result.id, cardsImageUrl: result.fileUrl });
    });
  }

  resetLogoInput() {
    this.companyForm.patchValue({ logoId: null, logoUrl: null });
    this.logoInput.nativeElement.value = null;
  }

  resetCardsImageInput() {
    this.companyForm.patchValue({ cardsImageId: null, cardsImageUrl: null });
    this.cardsImageInput.nativeElement.value = null;
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
}
